import Vue from 'vue'

import { getUniqueKey } from '@/utils/func'

Vue.mixin({
    data () {
        return {
            isDev: /(localhost|127.0.0.1)|(test|develop)(.*).guokr.net/.test(window.location.host),
            location: {
                push (url) {
                    window.top.location.href = url
                },
                replace (url) {
                    window.top.location.replace(url)
                },
                back () {
                    window.history.back()
                }
            }
        }
    },
    methods: {
        copyObject (obj = {}) {
            const copy = Object.create(Object.getPrototypeOf(obj))
            const propNames = Object.getOwnPropertyNames(obj)

            propNames.forEach((name) => {
                const desc = Object.getOwnPropertyDescriptor(obj, name)
                Object.defineProperty(copy, name, desc)
            })
            return copy
        },
        getUniqueKey () {
            return getUniqueKey()
        },
    }
})
